<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowAdd"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoad"
    >
      <template slot-scope="scope" slot="callBackTagForm">
        <el-input v-model="scope.row.callBackTag" :disabled="scope.row.registered === 1"></el-input>
      </template>
      <template slot="registered" slot-scope="scope">
        <el-tag :class="getClass(scope.row.registered)">{{
          scope.row.registered === 0 ? '否' : '是'
        }}</el-tag>
      </template>
      <template slot="menuLeft">
        <el-button
          type="primary"
          icon="el-icon-position"
          @click="registerSelected"
          v-if="this.permission.callback_register_use"
          :disabled="registeredCount > 0"
        >
          启用注册
        </el-button>
        <el-button
          type="success"
          icon="el-icon-edit"
          @click="registerUpdate"
          v-if="this.permission.callback_register_update"
          :disabled="registeredCount === 0"
        >
          更新注册
        </el-button>
        <el-button
          type="danger"
          icon="el-icon-delete"
          @click="registerDelete"
          v-if="this.permission.callback_register_cancel"
          :disabled="registeredCount === 0"
        >
          取消注册
        </el-button>
        <el-button
          type="primary"
          icon="el-icon-view"
          @click="registerDetails"
          plain="true"
          v-if="this.permission.callback_register_info"
        >
          注册详情
        </el-button>
      </template>
    </avue-crud>
    <el-form ref="form" :model="form" label-width="200px">
      <el-row>
        <el-col offset="10">
          <el-form-item label="@copyright by v4ward"></el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </basic-container>
</template>

<script>
import { getDictionaryWithIntKey } from '../../../api/common';
import {
  getList,
  register,
  registerDelete,
  registerUpdate,
  registerDetails,
  add,
  del,
  update,
} from '../../../api/v4ward/dingtalk/callback-tag';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      rules: {},
      data: [],
      loading: false,
      selectionList: [],
      registeredCount: 0,
      option: {
        tip: false,
        border: true,
        page: false,
        index: false,
        viewBtn: false,
        selection: true,
        align: 'center',
        dialogHeight: 250,
        dialogWidth: '30%',
        column: [
          {
            label: 'ID',
            prop: 'id',
            width: 170,
            hide: true,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '事件类型',
            prop: 'callBackTag',
            span: 24,
            formslot: true,
            rules: [
              {
                required: true,
                message: '请输入事件类型',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '类别',
            prop: 'tagType',
            span: 24,
            rules: [
              {
                required: true,
                message: '请输入事件类别',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '是否注册',
            prop: 'registered',
            slot: true,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '事件说明',
            span: 24,
            prop: 'remark',
            rules: [
              {
                required: true,
                message: '请输入事件说明',
                trigger: 'blur',
              },
            ],
          },
        ],
      },
    };
  },
  created() {},
  mounted() {},
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.callback_tag_add, true),
        viewBtn: false,
        delBtn: this.vaildData(this.permission.callback_tag_del, true),
        editBtn: this.vaildData(this.permission.callback_tag_edit, true),
      };
    },
  },
  methods: {
    getClass(reg) {
      if (reg === 0) {
        return 'tag-unregister';
      }
    },
    registerDetails() {
      registerDetails().then((res) => {
        console.log(JSON.stringify(res));
        this.$alert(res.data, '注册详情', {
          confirmButtonText: '确定',
          callback: (action) => {},
        });
      });
    },
    registerSelected() {
      this.loading = true;
      var tags = this.checkSelected();
      register(tags)
        .then((res) => {
          console.log(JSON.stringify(res));
          this.$message.success('注册成功！');
          this.onLoad();
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    registerUpdate() {
      this.loading = true;
      var tags = this.checkSelected();
      if (tags) {
        registerUpdate(tags)
          .then((res) => {
            console.log(JSON.stringify(res));
            this.$message.success('注册更新成功！');
            this.onLoad();
          })
          .catch((err) => {
            this.loading = false;
          });
      }
    },
    registerDelete() {
      console.log('取消注册回调。。。');
      this.$confirm('确定后将不再接收任何回调消息，确定?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return registerDelete();
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    checkSelected() {
      if (this.selectionList.length === 0) {
        this.$message.error('请选择注册事件！');
        return false;
      }
      var tags = '';
      this.selectionList.forEach((e) => {
        tags += e.callBackTag + ',';
      });
      return tags;
    },
    async resetSelection(list) {
      let crud = this.$refs.crud;
      setTimeout(function () {
        crud.selectClear();
        crud.toggleSelection(list);
      }, 100);
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    refreshChange() {
      this.onLoad();
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowAdd(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      if (row.registered === 1) {
        this.$alert('已经注册了回调，不能删除！', '提示信息', {
          confirmButtonText: '确定',
          callback: (action) => {},
        });
        return;
      }
      this.$confirm('确定删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return del(row.id);
        })
        .then(() => {
          this.onLoad();
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
        });
    },
    onLoad() {
      this.loading = true;
      getList().then((res) => {
        this.loading = false;
        this.data = res.data;
        this.registeredCount = 0;
        this.data.forEach((e) => {
          if (e.registered === 1) {
            this.selectionList.push(e);
            this.registeredCount++;
          }
        });
        this.resetSelection(this.selectionList);
      });
    },
  },
};
</script>

<style>
.el-divider--horizontal {
  margin: 8px 0;
  background: 0 0;
  border-top: 1px solid #e8eaec;
}

.el-dialog__body .el-col {
  margin-bottom: 2px;
  margin-top: 2px;
}

.tag-unregister {
  background-color: #fdffe0;
  color: red;
}

.money-text-align .el-input--small .el-input__inner {
  text-align: center;
}
</style>
